export default __webpack_public_path__ + "static/media/calendar.c6b292cf.png";